import { create, StoreApi, useStore } from 'zustand';

import { DrawCamerapathStateEnum } from '@spazious/dollhouse-types';

export interface DrawCamerapathState {
  active: boolean;
  state: DrawCamerapathStateEnum;
}

export interface DrawCamerapathStoreState extends DrawCamerapathState {
  set: StoreApi<DrawCamerapathState>['setState'];
  get: StoreApi<DrawCamerapathState>['getState'];
}

const createDrawCamerapathStore = (initialState?: Partial<DrawCamerapathState>) =>
  create<DrawCamerapathStoreState>((set, get) => ({
    set,
    get,
    active: false,
    state: DrawCamerapathStateEnum.Initial,
    ...initialState,
  }));

const store = createDrawCamerapathStore();

export const useDrawCamerapath = () => {
  const state = useStore(store);
  const set = store.getState().set;
  const get = store.getState().get;

  return { ...state, set, get };
};
